import { useQuery } from '@tanstack/react-query';

import { getOfferingDocuments } from '@arrived/api_v2';
import { OfferingDocument, OfferingId } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions, UseQueryResult } from '../queries.utils';
import { offeringDocumentsKeyFn } from './offerings.keys';

export function useOfferingDocumentsQuery(
  offeringId?: OfferingId,
  options?: UseQueryOptions<OfferingDocument[]>
): UseQueryResult<OfferingDocument[]> {
  return useQuery(offeringDocumentsKeyFn(offeringId!), async () => getOfferingDocuments(offeringId!), {
    ...options,
    enabled: (options?.enabled ?? true) && offeringId != null,
    staleTime: options?.staleTime ?? MAX_STALE_TIME,
  });
}
